import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
  Checkbox,
} from "@mui/material";

function SmmPostContent() {
  usePageTitle("Content Upload");
  const { ref } = useParams();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [uploading, setUploading] = useState(true);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadError, setUploadError] = useState("");

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      await axios
        .get(`smm/execution/${ref}/process.json`)
        .then((result) => {
          console.log(result);
          setUploading(false);
          if (result.data.status === "success") {
            setUploadStatus(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);

            setUploadStatus(false);
          }
          setUploadError(result.data.data.message);
        })
        .catch(() => {
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);

          setUploadError(
            "An unexpected error was encountered. Try again later.",
          );
          setUploading(false);
          setUploadStatus(false);
        });
    };

    fetchData();
  }, []);

  return (
    <>
      <Box mb={5}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Box sx={{ width: "100%", maxWidth: "600px", margin: "65px auto" }}>
        <Box p={3}>
          <Paper elevation={3}>
            <Box p={2}>
              {uploading ? (
                <Box align="center">
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="indeterminate"
                        size={120}
                        thickness={1.3}
                        color="info"
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="info" fontSize="large">
                          upload
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                  <Box mt={2}>
                    <Typography variant="body1" fontSize={14}>
                      We are uploading your content. Please wait a few
                      moments...
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box align="center">
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color={uploadStatus ? "success" : "error"}
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon
                          color={uploadStatus ? "success" : "error"}
                          fontSize="large"
                        >
                          {uploadStatus ? "check" : "close"}
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                  <Box mt={2}>
                    <Typography variant="body1" fontSize={14} fontWeight={600}>
                      {uploadError}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      startIcon={<Icon>cancel</Icon>}
                      onClick={() => {
                        window.close();
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default SmmPostContent;
